import {
    GET_ALL_PRODUCTS,
    GET_SINGLE_PROJECT,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
} from './bidDepositTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_PRODUCTS:
            return {
                ...state,
                all_products: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        case GET_SINGLE_PROJECT:
            return {
                ...state,
                search_allprojectdeposit: action.payload,
            }
        default:
            return state
    }
}
